import React from "react";
import Events from "components/events";
import StaffManagement from "components/staff-management";


const StaffManagementCheckInSetupSubPage = ({ event, checkQr }) => {
    const onGenerateFirstQr = (savedEvent) => checkQr.generateQr({
        coordinatesKey: Events.Helpers.CheckQr.getCheckQrCoordinatesKey(savedEvent),
        location: savedEvent,
    });

    return (
        <div className="staff-management-check-in-setup row-grid grid-gap-45 col-lg-5-3 align-items-start">
            <StaffManagement.Forms.CheckInSetup
                key={ event.id }
                event={ event }
                onGenerateFirstQr={ onGenerateFirstQr }
                onSavingChange={ checkQr.setLocationSaving }
                isQrRequestInFlight={ checkQr.isGenerationInFlight }
                qrStatus={ checkQr.status }
                qrLoading={ checkQr.loading } />
            <StaffManagement.Fields.CheckInQr event={ event } checkQr={ checkQr } />
        </div>
    );
};

export default StaffManagementCheckInSetupSubPage;
